module.exports = __webpack_public_path__ + "img/hand-swipe.b89dd006.svg";